import { ArrowLeftOutlined, CopyOutlined } from '@ant-design/icons';
import { Typography, Button, message, Flex } from 'antd';
import React from 'react';
import { useAIChat } from '../AiChatProvider';
import { copyToClipboard } from '../../../utils/common';
import AttachFileCard from './AttachFileCard';

const handleCopy = (content) => {
  copyToClipboard(content);
  message.success('Copied to clipboard');
};

const OneDocAiQuestion = React.memo(({ chat, isTopInStack, popQuestionIfAllowed }) => {
  return (
    <div className="prompt-question-box">
      <div className="chat-bubble-container">
        {isTopInStack && chat?.allowGoBack && (
          <Button onClick={popQuestionIfAllowed} type="primary" icon={<ArrowLeftOutlined />} className="go-back-btn" />
        )}
        <Flex wrap gap="middle" vertical={false} align="center" justify="end" style={{ margin: '10px 0px' }}>
          {chat?.attachedFiles
            ?.filter((file) => file.isDirectlyAttached)
            .map((file) => (
              <AttachFileCard
                key={file.id}
                filename={file.title}
                filetype={file.type}
                previewUrl={file?.url}
                style={{ width: '160px' }}
              />
            ))}
        </Flex>

        <div className="prompt-question">{chat.content}</div>

        <div className="chat-actions">
          <Button type="text" icon={<CopyOutlined />} onClick={() => handleCopy(chat.content)} />
        </div>
      </div>
    </div>
  );
});

export default OneDocAiQuestion;
